/**
 * Urine Test Formula
 * Uses the same comparison semantics as admin:
 * - text normal ranges are comma-separated lists
 * - numeric normal ranges support ranges and thresholds
 */

import { compareValues } from "./labComparison";

const FIELD_LABEL = {
  color: "Color",
  clarity: "Appearance",
  ph: "pH",
  specificGravity: "Specific Gravity",
  protein: "Protein",
  glucose: "Glucose",
  ketones: "Ketones",
  blood: "Blood",
  bilirubin: "Bilirubin",
  urobilinogen: "Urobilinogen",
  leukocytes: "Leukocytes",
  nitrite: "Nitrite",
  redBloodCells: "Red Blood Cells",
  whiteBloodCells: "White Blood Cells",
  epithelialCells: "Epithelial Cells",
  bacteria: "Bacteria",
};

const URINE_RULES = {
  protein: "Negative,Neg,Trace",
  glucose: "Negative,Neg",
  redBloodCells: "0-2",
  whiteBloodCells: "0-5",
};

const UrineTestFormula = (urineData) => {
  if (!urineData || typeof urineData !== "object") {
    return {
      status: "ไม่มีข้อมูล",
      color: "gray",
      description: "ไม่พบข้อมูลการตรวจปัสสาวะ",
      abnormalFindings: [],
    };
  }

  const abnormalFindings = [];

  Object.entries(URINE_RULES).forEach(([field, normalRange]) => {
    const value = urineData[field];
    const comparison = compareValues(normalRange, value, FIELD_LABEL[field]);

    if (comparison.status !== "normal" && comparison.label !== "-") {
      abnormalFindings.push(FIELD_LABEL[field]);
    }
  });

  if (abnormalFindings.length === 0) {
    return {
      status: "ปกติ",
      color: "green",
      description: "ผลการตรวจปัสสาวะอยู่ในเกณฑ์ปกติ",
      abnormalFindings: [],
    };
  }

  return {
    status: "ผิดปกติ",
    color: "red",
    description: `พบค่าผิดปกติ: ${abnormalFindings.join(", ")}`,
    abnormalFindings,
  };
};

export default UrineTestFormula;
